import { FaFileAlt, FaPuzzlePiece, FaShieldAlt, FaRocket, FaDatabase, FaUserCheck, FaEye, FaChalkboardTeacher, FaSlidersH, FaHeadset } from "react-icons/fa";
import { useState } from "react";
import { motion } from 'framer-motion';

const Features = () => {
    const [hoveredIndex, setHoveredIndex] = useState(null);
    const features = [
        { icon: <FaFileAlt className="text-[#2a627a] text-5xl" />, title: "Project Documentation", description: "We ensure thorough documentation throughout the development process, providing clear and detailed insights into every phase of the project." },
        { icon: <FaPuzzlePiece className="text-[#2a627a] text-5xl" />, title: "Integration Ready", description: "Our solutions are built to integrate seamlessly with your existing healthcare systems, ensuring a smooth transition and easy communication." },
        { icon: <FaDatabase className="text-[#2a627a] text-5xl" />, title: "Data Backup/Restore", description: "We implement robust backup and restore solutions to safeguard your critical healthcare data, ensuring business continuity." },
        { icon: <FaUserCheck className="text-[#2a627a] text-5xl" />, title: "Client Engagement", description: "We prioritize close collaboration with clients, ensuring that our solutions align with your vision and goals for your healthcare organization." },
        { icon: <FaEye className="text-[#2a627a] text-5xl" />, title: "Complete Transparency", description: "Stay informed and in control throughout the project with complete transparency in our development process, from concept to deployment." },
        { icon: <FaShieldAlt className="text-[#2a627a] text-5xl" />, title: "Data Protection", description: "Implement industry-leading security practices to protect patient data and comply with healthcare regulations such as HIPAA." },
        { icon: <FaHeadset className="text-[#2a627a] text-5xl" />, title: "Wide Last Services", description: "We provide extensive after-deployment services, ensuring ongoing support and timely updates to keep your systems running smoothly." },
        { icon: <FaSlidersH className="text-[#2a627a] text-5xl" />, title: "Advanced Customization", description: "Get tailored software solutions that cater specifically to your unique requirements, enhancing functionality and operational efficiency." },
        { icon: <FaRocket className="text-[#2a627a] text-5xl" />, title: "Fast Deployment", description: "Our team prioritizes rapid deployment without compromising on quality, ensuring your healthcare software is operational as quickly as possible." },
        { icon: <FaChalkboardTeacher className="text-[#2a627a] text-5xl" />, title: "User Training", description: "Ensure your team is fully trained on new systems and technologies to make the most of your healthcare software investment." }
    ]

    return (
        <div className="p-12  min-h-screen flex flex-col items-center">
            <h1 className="text-[30px] w-full  font-extrabold text-center bg-gradient-to-l from-[#2a627a] text-gray-800 rounded-xl mb-6">
                <span className="relative">
                    <span className="text-transparent  bg-clip-text bg-[#2a627a] mr-3 ">
                        Everything
                    </span>
                    {/* <span
                        className="absolute left-0 bottom-0 w-full h-[4px] bg-[#2a627a] rounded-full animate-pulse"
                    ></span> */}
                    <span className="text-gray-800 bot ">You Need, Right Here!</span>
                </span>
                <br />

            </h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-8 max-w-full">
                {features.map((item, index) => (
                    <motion.div
                        key={index}
                        className={`p-6 bg-gray-300 bg-opacity-70 rounded-2xl shadow-lg flex items-center space-x-6 transition-all duration-300 transform ${hoveredIndex === index ? "scale-105 bg-indigo-100 shadow-2xl" : "hover:scale-105 hover:bg-indigo-50"
                            }`}
                        onMouseEnter={() => setHoveredIndex(index)}
                        onMouseLeave={() => setHoveredIndex(null)}
                        initial={{ opacity: 0, y: 30, scale: 0.95 }}
                        whileInView={{ opacity: 1, y: 0, scale: 1 }}
                        transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.1 }}
                        viewport={{ once: false, amount: 0.3 }}
                        whileHover={{ scale: 1.08 }}
                    >
                        <motion.div
                            className="p-4 bg-indigo-200 rounded-full"
                            initial={{ rotate: -10 }}
                            whileHover={{ rotate: 10, scale: 1.1 }}
                            transition={{ type: "spring", stiffness: 100 }}
                        >
                            {item.icon}
                        </motion.div>
                        <div>
                            <h2 className="text-lg font-bold text-gray-900">{item.title}</h2>
                            <p className="text-gray-600 mt-2 text-sm">{item.description}</p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default Features;
